
import camelCaseKeysToUnderscore from '~/utils/stringTransform/camelCaseKeysToUnderscore'
import slotsSearchFistVisitQuery from '~/graphql/products/queries/slotsSearchFirstVisit.graphql'

export default {
  name: 'CheckoutWidgetAddToCart',
  inject: ['modal'],

  data () {
    return {
      query: {},
      isAppointmentProduct: null,
      isReservedAppointment: null,
      modalId: '',
    }
  },

  computed: {
    getModalData () {
      return this.$store.state.modal.modalData
    },
  },

  watch: {
    getModalData (data) {
      if (data?.type === 'CheckoutWidgetAddToCartModal') {
        this.modalId = data?.modalId
      }
    },
  },

  async mounted () {
    this.query = { ...this.$route.query }

    if (Object.values(this.query).length && this.query.site_sku) {
      window.__APPOINTMENT__ = {
        path: this.$route.fullPath,
        query: this.query,
      }

      await this.showModal()

      this.$router.replace({ query: null })

      this.isAppointmentProduct = this.query.clinic && this.query.doctor && this.query.specialty
      this.isReservedAppointment = !!this.query.reservation_id

      if (this.isAppointmentProduct && !this.isReservedAppointment) {
        this.getSlotDataAppointment()
      } else {
        this.addToCart()
      }
    }
  },

  methods: {
    async getSlotDataAppointment () {
      const variables = {
        clinics: [this.query.clinic],
        doctors: [this.query.doctor],
        regions: [this.query.region],
        specialities: [this.query.specialty],
        vendors: [this.query.vendor],
        startDate: this.query.date,
        sizePerDay: 10,
        visitType: 3,
      }

      await this.$graphql({
        requestPayload: {
          query: slotsSearchFistVisitQuery,
          variables,
        },
        successHandler: ({ data: { slotsSearchFirstVisit: { groupedByDay: [items] } } }) => {
          const slot = items?.slots?.find(({ date }) => date === this.query.date)

          if (!slot) {
            return this.showError(this.$t('checkout.Your appointment date is unfortunately not available Please search again'))
          }

          this.addToCart(slot)
        },
        errorHandler: ({ message }) => {
          this.showError(message)
        },
      })
    },

    async addToCart (slot) {
      let cartInput = []
      let mutationTypeName = ''

      if (!this.$cart.cartId()) {
        await this.$store.dispatch('checkout/createEmptyCart')
      }

      if (this.isReservedAppointment) {
      // slot zarezerwowany (ma reservation_id)
        cartInput = [{
          data: {
            sku: this.query.site_sku,
            quantity: 1,
          },

          customizableOptions: [{
            variantCode: this.query.variant_code,
          }],

          reserveData: {
            appointmentsDate: this.query.date,
            reservationId: this.query.reservation_id,
            duration: Number(this.query.duration),
            vendor: { code: this.query.vendor, description: '' },
            region: { code: this.query.region, description: '' },
            doctor: { code: this.query.doctor, description: '' },
            specialty: { code: this.query.specialty, description: '' },
            clinic: { code: this.query.clinic, description: '' },
          },
        }]

        mutationTypeName = 'AppointmentProductByWidget'
      } else if (this.isAppointmentProduct) {
      // slot wyszukany (nie ma reservation_id)
        const { date: appointmentsDate, duration } = slot

        const appointment = ['vendor', 'region', 'doctor', 'specialty', 'clinic'].reduce((acc, key) => {
          const { code, description } = slot[key]

          acc[key] = {
            code,
            description,
          }

          return acc
        }, {})

        cartInput = [{
          data: {
            sku: this.query.site_sku,
            quantity: 1,
          },

          customizableOptions: [{
            variantCode: this.query.variant_code,
          }],

          reserveData: {
            appointmentsDate,
            duration,
            ...appointment,
          },

        }]

        mutationTypeName = 'AppointmentProductByWidget'
      } else {
        // nie slot (prod fiz?)
        cartInput = [{
          data: {
            sku: this.query.site_sku,
            quantity: 1,
          },

          customizableOptions: [{
            variantCode: this.query.variant_code,
          }],
        }]

        mutationTypeName = 'PhysicalProduct'
      }

      this.$graphql({
        requestPayload: {
          mutation: this.$cart.addToCartMutation(mutationTypeName),
          variables: camelCaseKeysToUnderscore(this.$cart.addToCartInput(cartInput)()),
        },
        successHandler: async ({ data }) => {
          await this.$cart.addedToCart(data)

          await this.onHideModal()
        },
        errorHandler: ({ message }) => {
          this.showError(message)
        },
      })
    },

    async onHideModal () {
      const modalInstance = await this.modal()

      modalInstance.closeModal(this.modalId)
    },

    async showModal () {
      try {
        const CheckoutWidgetAddToCartModal = await import('@strix/checkout/components/widget/CheckoutWidgetAddToCartModal.vue')
        const modalInstance = await this.modal()

        await modalInstance.openModal(CheckoutWidgetAddToCartModal.default, {}, { height: [{ mobile: '80vh', desktop: '60vh' }] })
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      }
    },

    showError (errorMsg) {
      this.onHideModal()

      this.$toast.add({
        text: errorMsg,
        type: 'error',
        place: this.$toast.places.header,
      })
    },
  },
}
